import { formatDate } from 'src/utils/formatTime';

const flag = value => (value === null || value === undefined ? null : value ? 'Yes' : 'No');

// Only an installation import measures these: it installs the app and watches what Windows did.
// Every other path writes the columns without observing anything, so a caller that can tell the
// sources apart should draw them for that source alone rather than report a default as a finding.
export const INSTALLATION_FIELDS = [
  {
    label: 'Installation Trusted by the Intelligent Security Graph (ISG)',
    read: detail => flag(detail.installTrustedByISG),
  },
  {
    label: 'ISG Installation Validated On',
    read: detail =>
      detail.installTrustedByISGDate ? formatDate(detail.installTrustedByISGDate) : null,
  },
  {
    label: 'Installation Blocked by Dynamic Code Execution',
    read: detail => flag(detail.installBlockedByDynamicCodeSecurity),
  },
  {
    label: 'Execution Trusted by the Intelligent Security Graph (ISG)',
    read: detail => flag(detail.executionTrustedByISG),
  },
  {
    label: 'ISG Execution Validated On',
    read: detail =>
      detail.executionTrustedByISGDate ? formatDate(detail.executionTrustedByISGDate) : null,
  },
  {
    label: 'Execution Blocked By Dynamic Code Security',
    read: detail => flag(detail.executionBlockedByDynamicCodeSecurity),
  },
];
